import apiService from "../../api/api.service";
import { FloatingContentResponse } from "./floatingContent.types";

export const fetchFloatingContent = () => {
  return apiService.get<FloatingContentResponse>("/general/floating-content");
};
